import { render, staticRenderFns } from "./ParamsTypeFiles.vue?vue&type=template&id=9e8ef274&scoped=true&"
import script from "./ParamsTypeFiles.ts?vue&type=script&lang=ts&"
export * from "./ParamsTypeFiles.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8ef274",
  null
  
)

export default component.exports
import {QTable,QBtn,QTooltip,QSpace,QInput,QIcon,QTr,QTd,QPopupEdit,QDialog,QCard,QBar,QCardSection,ClosePopup} from 'quasar'
component.options.components = Object.assign({QTable,QBtn,QTooltip,QSpace,QInput,QIcon,QTr,QTd,QPopupEdit,QDialog,QCard,QBar,QCardSection}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
